"use client";

import * as React from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { X } from "lucide-react";
const coffeeItems = [{
  name: "Sultani Smash Burger",
  description: "Double wagyu beef, caramelized onions, secret Sultani sauce",
  price: "$14.50"
}, {
  name: "The Desi Heat Burger",
  description: "Spicy masala patty, ghost pepper jack, pickled chilies",
  price: "$15.00"
}, {
  name: "Lahori Fish Burger",
  description: "Crispy battered cod, mint chutney slaw, brioche bun",
  price: "$13.25"
}, {
  name: "Paneer Tikka Burger",
  description: "Grilled paneer, tandoori mayo, crisp lettuce",
  price: "$12.50"
}, {
  name: "Classic Cheeseburger",
  description: "Angus beef, sharp cheddar, house pickles, mustard",
  price: "$11.00"
}, {
  name: "BBQ Brisket Burger",
  description: "Slow-smoked brisket, hickory BBQ, crispy onions",
  price: "$16.00"
}, {
  name: "The Royal Lamb Burger",
  description: "Ground lamb, feta, cucumber raita, red onion",
  price: "$15.50"
}, {
  name: "Chicken Tikka Burger",
  description: "Char-grilled chicken, spicy yogurt marinade",
  price: "$13.75"
}];
const teaItems = [{
  name: "Chicken Karahi",
  description: "Traditional wok-cooked chicken with ginger and green chilies",
  price: "$18.00"
}, {
  name: "Mutton Karahi",
  description: "Tender goat meat in a rich tomato and spice reduction",
  price: "$22.50"
}, {
  name: "Paneer Karahi",
  description: "Cottage cheese cubes in a spicy, aromatic gravy",
  price: "$16.00"
}, {
  name: "Peshawari Karahi",
  description: "Mildly spiced with black pepper and fresh tomatoes",
  price: "$19.50"
}, {
  name: "Mixed Vegetable Karahi",
  description: "Seasonal farm-fresh vegetables in Punjabi spices",
  price: "$15.00"
}, {
  name: "Butter Chicken Karahi",
  description: "Creamy tomato base with charcoal-grilled chicken",
  price: "$18.75"
}];
const pastryItems = [{
  name: "Masala Fries",
  description: "Hand-cut potatoes tossed in our signature spice blend",
  price: "$5.50"
}, {
  name: "Garlic Naan",
  description: "Clay oven baked bread with fresh garlic and cilantro",
  price: "$4.00"
}, {
  name: "Samosa Chaat",
  description: "Crushed samosas with chickpeas, yogurt, and tamarind",
  price: "$8.00"
}, {
  name: "Mango Lassi",
  description: "Creamy yogurt drink with Alphonso mango pulp",
  price: "$5.25"
}, {
  name: "Gulab Jamun",
  description: "Warm milk dumplings in cardamom sugar syrup",
  price: "$6.00"
}, {
  name: "Pakora Basket",
  description: "Assorted vegetable fritters with mint chutney",
  price: "$7.50"
}];
export default function TheEspressoBar() {
  const [expandedImage, setExpandedImage] = React.useState(null);
  return <section data-section-id="230367" id="the-full-spread" className="w-full bg-background py-16 md:py-24 lg:py-32">
      <div className="container mx-auto px-4 md:px-6 max-w-5xl">
        <div className="flex flex-col items-center text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-foreground mb-4 tracking-wider uppercase">
            The Full Spread
          </h2>
          <p className="text-primary font-serif text-lg mb-2 uppercase tracking-wide">
            Authentic Flavors, Modern Craft
          </p>
          <p className="text-muted-foreground text-base md:text-lg max-w-2xl font-default">
            Experience the bold fusion of Punjabi spices and American classics. Every dish is certified halal and crafted for impact.
          </p>
          <div className="mt-12 flex flex-col gap-8 w-full max-w-5xl">
            <img src="https://logical-turkey.10web.cloud/wp-content/uploads/2026/04/VERSION1.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1648254/img/sultani_burger_spread.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1648254/img/sultani_burger_spread.png-wvc-sizes" alt="Sultani Burger Spread" className="w-full h-auto rounded-lg shadow-xl object-contain cursor-pointer transition-transform hover:scale-[1.01]" loading="lazy" decoding="async" onClick={() => setExpandedImage('sultani')} />
            <img src="https://logical-turkey.10web.cloud/wp-content/uploads/2026/04/VERSION2.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1648254/img/karahi_cooking_close_up.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1648254/img/karahi_cooking_close_up.png-wvc-sizes" alt="Karahi Cooking Close Up" className="w-full h-auto rounded-lg shadow-xl object-contain cursor-pointer transition-transform hover:scale-[1.01]" loading="lazy" decoding="async" onClick={() => setExpandedImage('karahi')} />
          </div>
        </div>
      </div>

      {expandedImage === 'sultani' && <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 p-4 md:p-8 animate-in fade-in duration-200" onClick={() => setExpandedImage(null)}>
          <div className="relative max-w-7xl w-full h-full flex items-center justify-center">
            <button onClick={e => {
          e.stopPropagation();
          setExpandedImage(null);
        }} className="absolute top-0 right-0 m-4 p-2 text-white hover:text-primary transition-colors z-60" aria-label="Close dialog">
              <X className="size-8" />
            </button>
            <img src="https://logical-turkey.10web.cloud/wp-content/uploads/2026/04/v1.png" alt="Sultani Burger Spread Full View" className="max-w-full max-h-full object-contain rounded-md shadow-2xl" onClick={e => e.stopPropagation()} />
          </div>
        </div>}

      {expandedImage === 'karahi' && <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 p-4 md:p-8 animate-in fade-in duration-200" onClick={() => setExpandedImage(null)}>
          <div className="relative max-w-7xl w-full h-full flex items-center justify-center">
            <button onClick={e => {
          e.stopPropagation();
          setExpandedImage(null);
        }} className="absolute top-0 right-0 m-4 p-2 text-white hover:text-primary transition-colors z-60" aria-label="Close dialog">
              <X className="size-8" />
            </button>
            <img src="https://logical-turkey.10web.cloud/wp-content/uploads/2026/04/v2.png" alt="Karahi Cooking Full View" className="max-w-full max-h-full object-contain rounded-md shadow-2xl" onClick={e => e.stopPropagation()} />
          </div>
        </div>}
    </section>;
}